// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/Pagine_Background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.text-overflow__b4b7Q {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-gradient__yv7BX {
  background-image: -webkit-gradient(linear, 37.219838% 34.532506%, 36.425669% 93.178216%, from(#29cdff), to(#0a60ff), color-stop(0.37, #148eff));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.background-hover__bJqLX {
  transition: all 0.3s ease-out;
}
.background-hover__bJqLX:hover {
  background-color: #f9f9fc;
}
.backTop__vkMcV {
  right: 50px;
}
.backTop__vkMcV .ant-back-top-content {
  background: #e61e1e;
  opacity: 0.3;
  transition: all 0.3s;
  box-shadow: 0 0 15px 1px rgba(69, 65, 78, 0.1);
}
.backTop__vkMcV .ant-back-top-content:hover {
  opacity: 1;
}
.content__Q4d52 {
  padding: 24px;
  min-height: calc(100% - 72px);
  overflow-y: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  height: calc(100% - 72px);
  border: 0px solid;
}
.adminLayoutContent__eDYuT {
  height: 100vh;
  flex: 1;
  width: calc(100% - 256px);
  overflow-y: hidden;
  overflow-x: hidden;
  border: 0px solid;
}
.container__FvmOF {
  height: 100vh;
  flex: 1;
  width: calc(100% - 256px);
  overflow-y: hidden;
  overflow-x: hidden;
  border: 0px solid;
}
.footer__bsHV6 {
  background: #fff;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 24px;
  padding-bottom: 24px;
  min-height: 72px;
}
@media (max-width: 767px) {
  .content__Q4d52 {
    padding: 12px;
  }
  .backTop__vkMcV {
    right: 20px;
    bottom: 20px;
  }
  .container__FvmOF {
    height: 100vh;
    flex: 1;
    width: 100%;
    border: 0px solid;
  }
}
/*# sourceMappingURL=PrimaryLayout.module.css.map */`, "",{"version":3,"sources":["webpack://./src/Layouts/PrimaryLayout.module.less","webpack://./src/Themes/mixin.less","webpack://./PrimaryLayout.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACO7F;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ADLF;ACQA;EACE,+IAAA;EAQA,6BAAA;EACA,oCAAA;ADbF;ACgBA;EACE,6BAAA;ADdF;ACeE;EACE,yBAAA;ADbJ;AEhBA;EACI,WAAA;AFkBJ;AEnBA;EAKQ,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,8CAAA;AFiBR;AEfQ;EACE,UAAA;AFiBV;AEXE;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,iFAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;AFaJ;AEVE;EACE,aAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AFYJ;AETE;EACE,aAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AFWJ;AEPE;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AFSJ;AENE;EACE;IACE,aAAA;EFQJ;EELE;IACE,WAAA;IACA,YAAA;EFOJ;EEJE;IACE,aAAA;IACA,OAAA;IACA,WAAA;IACA,iBAAA;EFMJ;AACF;AACA,mDAAmD","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.text-gradient {\n  background-image: -webkit-gradient(linear, 37.219838% 34.532506%, 36.425669% 93.178216%, from(#29cdff), to(#0a60ff), color-stop(0.37, #148eff));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.background-hover {\n  transition: all 0.3s ease-out;\n}\n.background-hover:hover {\n  background-color: #f9f9fc;\n}\n.backTop {\n  right: 50px;\n}\n.backTop :global .ant-back-top-content {\n  background: #e61e1e;\n  opacity: 0.3;\n  transition: all 0.3s;\n  box-shadow: 0 0 15px 1px rgba(69, 65, 78, 0.1);\n}\n.backTop :global .ant-back-top-content:hover {\n  opacity: 1;\n}\n.content {\n  padding: 24px;\n  min-height: calc(100% - 72px);\n  overflow-y: auto;\n  background: url(../assets/img/Pagine_Background.png) no-repeat center center fixed;\n  background-size: cover;\n  height: calc(100% - 72px);\n  border: 0px solid;\n}\n.adminLayoutContent {\n  height: 100vh;\n  flex: 1;\n  width: calc(100% - 256px);\n  overflow-y: hidden;\n  overflow-x: hidden;\n  border: 0px solid;\n}\n.container {\n  height: 100vh;\n  flex: 1;\n  width: calc(100% - 256px);\n  overflow-y: hidden;\n  overflow-x: hidden;\n  border: 0px solid;\n}\n.footer {\n  background: #fff;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  min-height: 72px;\n}\n@media (max-width: 767px) {\n  .content {\n    padding: 12px;\n  }\n  .backTop {\n    right: 20px;\n    bottom: 20px;\n  }\n  .container {\n    height: 100vh;\n    flex: 1;\n    width: 100%;\n    border: 0px solid;\n  }\n}\n/*# sourceMappingURL=PrimaryLayout.module.css.map */","@import './default.less'; \n\n@dark-half: #494949;\n@purple: #d897eb;\n@shadow-1: 4px 4px 20px 0 rgba(0, 0, 0, 0.01);\n@shadow-2: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);\n@transition-ease-in: all 0.3s ease-out;\n@transition-ease-out: all 0.3s ease-out;\n@ease-in: ease-in;\n\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.text-gradient {\n  background-image: -webkit-gradient(\n    linear,\n    37.219838% 34.532506%,\n    36.425669% 93.178216%,\n    from(#29cdff),\n    to(#0a60ff),\n    color-stop(0.37, #148eff)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.background-hover {\n  transition: @transition-ease-in;\n  &:hover {\n    background-color: @hover-color;\n  }\n}","\n@import '../Themes/vars.less';\n\n.backTop {\n    right: 50px;\n  \n    :global {\n      .ant-back-top-content {\n        background: @primary-color;\n        opacity: 0.3;\n        transition: all 0.3s;\n        box-shadow: 0 0 15px 1px rgba(69, 65, 78, 0.1);\n  \n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n  }\n  \n  .content {\n    padding: 24px;\n    min-height: ~'calc(100% - 72px)';\n    overflow-y: auto; //SE ABILITATA PARTE LA SCROLL NORMALE\n    background: url(../assets/img/Pagine_Background.png) no-repeat center center fixed;\n    background-size: cover;\n    height: ~'calc(100% - 72px)';\n    border: 0px solid;\n\n  }\n  .adminLayoutContent{\n    height: 100vh;\n    flex: 1;\n    width: ~'calc(100% - 256px)';\n    overflow-y: hidden;\n    overflow-x: hidden;\n    border: 0px solid;\n  }\n  \n  .container {\n    height: 100vh;\n    flex: 1;\n    width: ~'calc(100% - 256px)';\n    overflow-y: hidden;\n    overflow-x: hidden;\n    border: 0px solid;\n   \n  }\n  \n  .footer {\n    background: #fff;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    min-height: 72px;\n  }\n  \n  @media (max-width: 767px) {\n    .content {\n      padding: 12px;\n    }\n  \n    .backTop {\n      right: 20px;\n      bottom: 20px;\n    }\n  \n    .container {\n      height: 100vh;\n      flex: 1;\n      width: 100%;\n      border: 0px solid;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-overflow": `text-overflow__b4b7Q`,
	"text-gradient": `text-gradient__yv7BX`,
	"background-hover": `background-hover__bJqLX`,
	"backTop": `backTop__vkMcV`,
	"content": `content__Q4d52`,
	"adminLayoutContent": `adminLayoutContent__eDYuT`,
	"container": `container__FvmOF`,
	"footer": `footer__bsHV6`
};
export default ___CSS_LOADER_EXPORT___;
